import { Module } from 'vuex'
import { RootState } from '@/store'
import mutations from '@/store/hospital/mutations'
import { path } from '@/store/hospital/types'
import { mutation } from '@/utils/mutation'
import state, { IHospitalState } from '@/store/hospital/state'

export * from '@/store/hospital/state'

export const store: Module<IHospitalState, RootState> = {
  state,
  mutations: mutation(mutations, path)
}
